const IMAGES_MAP = {
  FISSARA_LOGO: `${process.env.REACT_APP_ASSETS_BASE_URL}/client-logos/Fissara.png`,
  CAREBEANS_LOGO: `${process.env.REACT_APP_ASSETS_BASE_URL}/client-logos/Carebeans.png`,
  DIGIALLY_LOGO: `${process.env.REACT_APP_ASSETS_BASE_URL}/client-logos/DigiAlly.png`,
  PATHLOCK_LOGO: `${process.env.REACT_APP_ASSETS_BASE_URL}/client-logos/Pathlock.png`,
  QFIX_LOGO: `${process.env.REACT_APP_ASSETS_BASE_URL}/client-logos/Qfix.png`,
  RIPPLEHIRE_LOGO: `${process.env.REACT_APP_ASSETS_BASE_URL}/client-logos/RippleHire.png`,
  PINELABS_LOGO: `${process.env.REACT_APP_ASSETS_BASE_URL}/client-logos/Pinelabs.png`,
  WTC_LOGO: `${process.env.REACT_APP_ASSETS_BASE_URL}/client-logos/WTC.png`,
};

export const CLIENT_LOGOS = [
  {
    image: IMAGES_MAP.FISSARA_LOGO,
    path: "https://www.fissara.com/about/",
    domain: "Resource Management",
  },
  {
    image: IMAGES_MAP.CAREBEANS_LOGO,
    path: "https://www.carebeans.co.uk/",
  },
  {
    image: IMAGES_MAP.DIGIALLY_LOGO,
    path: "https://www.digiallyglobal.com/",
    domain: "Fintech",
  },
  {
    image: IMAGES_MAP.PATHLOCK_LOGO,
    path: "https://pathlock.com/",
    domain: "Data Security",
  },
  {
    image: IMAGES_MAP.QFIX_LOGO,
    path: "https://www.eduqfix.com/",
    domain: "Education",
  },
  {
    image: IMAGES_MAP.RIPPLEHIRE_LOGO,
    path: "https://www.ripplehire.com/",
    domain: "Recruitment",
  },
  {
    image: IMAGES_MAP.PINELABS_LOGO,
    path: "https://www.pinelabs.com/",
    domain: "Payment",
  },
  {
    image: IMAGES_MAP.WTC_LOGO,
    path: "https://wtcmumbai.org/",
    domain: "Exhibitionz",
  },
];
